import { render, staticRenderFns } from "./DashboardCardSubscription.vue?vue&type=template&id=74850de0&scoped=true&"
import script from "./DashboardCardSubscription.vue?vue&type=script&lang=js&"
export * from "./DashboardCardSubscription.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCardSubscription.vue?vue&type=style&index=0&id=74850de0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74850de0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCardTitle,VImg,VSpacer})
